import styled from '@emotion/styled'
import { Chip } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`

export const StyledChip = styled(Chip)`
  background-color: ${colors.interactive.secondaryEnabled};
  border-radius: 100px;
  ${typography.baseline.regularSans}
  font-size: 13px;
  line-height: 18px;
  height: inherit;
  padding: 9px 4px;
  margin-right: 0;

  &.MuiChip-outlined {
    background-color: transparent;
    border-color: ${colors.interactive.secondaryEnabled};
    color: ${colors.text.primary};
  }

  &.MuiChip-filled {
    background-color: ${colors.interactive.secondaryEnabled};
    color: ${colors.text.primary};
  }

  & .MuiChip-deleteIcon {
    font-size: 18px;
  }
`
